export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-purple-600 via-purple-700 to-purple-800">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div className="md:col-span-1">
            <img 
              src="https://public.readdy.ai/ai/img_res/96a404ca-4b33-45a9-aff5-73665010c728.png" 
              alt="OPEN STUDIO d.o.o." 
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-purple-100 text-sm leading-relaxed max-w-xs">
              Protecting your digital privacy with enterprise-grade VPN solutions. Stay secure, stay anonymous.
            </p>
          </div>

          <div>
            <h3 className="text-white text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="text-purple-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-purple-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  About
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('vpn-service')}
                  className="text-purple-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  VPN Service
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('features')}
                  className="text-purple-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Features
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-purple-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white text-lg font-semibold mb-6">Contact Info</h3>
            <ul className="space-y-3 text-sm">
              <li className="text-purple-100">
                <a href="mailto:information@openstudiodoo.com" className="hover:text-white transition-colors cursor-pointer">
                  information@openstudiodoo.com
                </a>
              </li>
              <li className="text-purple-100">
                <a href="tel:+12137533391" className="hover:text-white transition-colors cursor-pointer">
                  +1 213 753 3391
                </a>
              </li>
              <li className="text-purple-100">
                Put Vrela 74c<br />
                23000 Zadar, Croatia
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-purple-500/30 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-purple-200 text-sm">
              © 2025 OPEN STUDIO d.o.o. All rights reserved
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-purple-200 hover:text-white text-sm transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <span className="text-purple-400">|</span>
              <a href="#" className="text-purple-200 hover:text-white text-sm transition-colors cursor-pointer">
                Terms of Service
              </a>
              <span className="text-purple-400">|</span>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-purple-200 hover:text-white text-sm transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
